export const isDevelopment = !location.origin.includes(
  "https://curriculum-fhelix-imc-ac-at.pages.dev",
);
export const API_BASE_URL = isDevelopment
  ? "https://localhost:5000"
  : "https://api.fh-krems.ac.at/v2.0";
